export default {
  title: 'Voer terugbetalingsbedrag in',
  description: 'Beschikbaar voor terugbetaling: {{amount}}',
  form: {
    amount: {
      label: 'Terugbetalen',
    },
    reason: {
      label: 'Reden',
      options: {
        requested_by_customer: 'verzocht door klant',
        reclamation: 'reclamatie',
        communication_error: 'communicatiefout',
        other: 'overig',
      },
    },
    manual_reason: {
      label: 'Voer reden voor terugbetaling in',
    },
  },
  feedback: {
    amount_too_small: 'Minimaal terugbetalingsbedrag {{amount}}',
    amount_too_big: 'Maximaal terugbetalingsbedrag {{amount}}',
    payment_frozen:
      'Terugbetaling al aangevraagd door klant. {{provider}} is in contact met de klant over de terugbetaling',
  },
  buttons: {
    refund: 'Terugbetalen',
    cancel: 'Annuleren',
  },
  toasts: {
    refund_successful: 'Terugbetaling van {{amount}} succesvol gestart!',
  },
};
